import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SortDirection } from '../../../shared';
import { getNestedValue, sortColumnDefinitions } from '../util/table-v2.utils';
import * as i0 from "@angular/core";
import * as i1 from "../service";
import * as i2 from "primeng/table";
import * as i3 from "primeng/api";
import * as i4 from "@angular/common";
import * as i5 from "../../../basic-features/icon-v2/icon.component";
import * as i6 from "../../../shared/directive/tooltip-on-ellipsis-v2.directive";
import * as i7 from "../../../basic-features/select-v2/select-v2.component";
import * as i8 from "ngx-skeleton-loader";
import * as i9 from "primeng/tooltip";
import * as i10 from "../directive/component-renderer.directive";
import * as i11 from "../directive/header-renderer.directive";
import * as i12 from "../directive/filter-renderer.directive";
import * as i13 from "../no-content/no-entries/no-entries.component";
import * as i14 from "../no-content/no-results/no-results.component";
import * as i15 from "../no-content/no-entries-process/no-entries-process.component";
import * as i16 from "@ngx-translate/core";
/**
 * @deprecated use v3 version of this component instead
 */
const _c0 = (a0, a1, a2, a3) => ({
  "no-data": a0,
  rowspan: a1,
  "p-datatable-striped": a2,
  "disable-hover-row-effect": a3
});
const _c1 = (a0, a1) => ({
  "sticky-left": a0,
  "sticky-right": a1
});
const _c2 = a0 => ({
  "left-header": a0
});
const _c3 = a0 => ({
  "header-linebreaks": a0
});
const _c4 = (a0, a1, a2) => ({
  isSorted: a0,
  asc: a1,
  desc: a2
});
const _c5 = a0 => ({
  "filter-active": a0
});
const _c6 = a0 => ({
  "no-resize": a0
});
const _c7 = (a0, a1, a2) => ({
  clickable: a0,
  highlight: a1,
  "odd-striping-color": a2
});
const _c8 = (a0, a1, a2) => ({
  "sticky-left": a0,
  "sticky-right": a1,
  "highlight-right": a2
});
const _c9 = () => ({});
const _c10 = (a0, a1, a2, a3) => [a0, a1, a2, a3];
const _c11 = () => ({
  height: "25px",
  width: "100%",
  "margin-bottom": 0
});
function TableV2Component_p_table_4_ng_template_3_th_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("geauiFilterOpenChange", function TableV2Component_p_table_4_ng_template_3_th_1_div_3_Template_div_geauiFilterOpenChange_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const col_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.filterOpenChanged($event, col_r4));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("geauiFilterRendererComponent", col_r4.filter.component)("geauiColumnKey", col_r4.key)("geauiColumnName", i0.ɵɵpipeBind1(1, 6, col_r4.displayName))("geauiRendererConfig", col_r4.filter.config)("geauiTableId", ctx_r1.tableId)("geauiFilterOpen", col_r4.filter.open);
  }
}
function TableV2Component_p_table_4_ng_template_3_th_1_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 22);
  }
  if (rf & 2) {
    const col_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("geauiHeaderRendererComponent", col_r4.headerRenderer.component)("geauiTableId", ctx_r1.tableId)("geauiDisplayName", col_r4.displayName)("geauiRendererConfig", col_r4.headerRenderer.config);
  }
}
function TableV2Component_p_table_4_ng_template_3_th_1_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 23);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3, ctx_r1.enableHeaderLineBreaks))("pTooltip", i0.ɵɵpipeBind1(1, 3, col_r4.displayName));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, col_r4.displayName), " ");
  }
}
function TableV2Component_p_table_4_ng_template_3_th_1_geaui_icon_v2_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v2", 24);
  }
  if (rf & 2) {
    const col_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("clickable", true)("ngClass", i0.ɵɵpureFunction3(2, _c4, ctx_r1.filterSettings.columns[col_r4.key] == null ? null : ctx_r1.filterSettings.columns[col_r4.key].sort, (ctx_r1.filterSettings.columns[col_r4.key] == null ? null : ctx_r1.filterSettings.columns[col_r4.key].sort) === ctx_r1.SortDirection.ASCENDING, (ctx_r1.filterSettings.columns[col_r4.key] == null ? null : ctx_r1.filterSettings.columns[col_r4.key].sort) === ctx_r1.SortDirection.DESCENDING));
  }
}
function TableV2Component_p_table_4_ng_template_3_th_1_div_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵlistener("click", function TableV2Component_p_table_4_ng_template_3_th_1_div_8_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const col_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r1.filterOpenChanged(!col_r4.filter.open, col_r4));
    });
    i0.ɵɵelement(1, "geaui-icon-v2", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("clickable", true)("ngClass", i0.ɵɵpureFunction1(2, _c5, (ctx_r1.filterSettings.columns[col_r4.key] == null ? null : ctx_r1.filterSettings.columns[col_r4.key].filter == null ? null : ctx_r1.filterSettings.columns[col_r4.key].filter.length) > 0 && (ctx_r1.filterSettings.columns[col_r4.key] == null ? null : ctx_r1.filterSettings.columns[col_r4.key].filter[0])));
  }
}
function TableV2Component_p_table_4_ng_template_3_th_1_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵlistener("click", function TableV2Component_p_table_4_ng_template_3_th_1_div_9_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      return i0.ɵɵresetView($event.stopPropagation());
    })("pointerdown", function TableV2Component_p_table_4_ng_template_3_th_1_div_9_Template_div_pointerdown_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const col_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.resizeStart($event, col_r4.key));
    });
    i0.ɵɵelement(1, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c6, col_r4.resizeable === false || !ctx_r1.tableId));
  }
}
function TableV2Component_p_table_4_ng_template_3_th_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 11)(1, "div", 12)(2, "div", 13);
    i0.ɵɵtemplate(3, TableV2Component_p_table_4_ng_template_3_th_1_div_3_Template, 2, 8, "div", 14)(4, TableV2Component_p_table_4_ng_template_3_th_1_div_4_Template, 1, 4, "div", 15)(5, TableV2Component_p_table_4_ng_template_3_th_1_span_5_Template, 4, 9, "span", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 17);
    i0.ɵɵtemplate(7, TableV2Component_p_table_4_ng_template_3_th_1_geaui_icon_v2_7_Template, 1, 6, "geaui-icon-v2", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, TableV2Component_p_table_4_ng_template_3_th_1_div_8_Template, 2, 4, "div", 19)(9, TableV2Component_p_table_4_ng_template_3_th_1_div_9_Template, 2, 3, "div", 20);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const col_r4 = ctx.$implicit;
    const colIndex_r7 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleProp("width", ctx_r1.getColWidth(col_r4, colIndex_r7), "px")("max-width", ctx_r1.getColWidth(col_r4, colIndex_r7), "px")("min-width", col_r4.minWidth, "px");
    i0.ɵɵproperty("pSortableColumn", ctx_r1.sortable ? col_r4.key : undefined)("pSortableColumnDisabled", col_r4.sortable === false || !ctx_r1.sortable)("alignFrozen", col_r4.frozen)("frozen", !!col_r4.frozen)("id", col_r4.key)("ngClass", i0.ɵɵpureFunction2(19, _c1, col_r4.frozen === "left", col_r4.frozen === "right"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(22, _c2, !col_r4.headerRenderer));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", col_r4.filter);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", col_r4.headerRenderer);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !col_r4.headerRenderer);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", col_r4.sortable !== false && ctx_r1.sortable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", col_r4.filter);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", colIndex_r7 !== ctx_r1.visibleColumns.length - 1);
  }
}
function TableV2Component_p_table_4_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, TableV2Component_p_table_4_ng_template_3_th_1_Template, 10, 24, "th", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const columns_r8 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", columns_r8);
  }
}
function TableV2Component_p_table_4_ng_template_4_ng_container_1_td_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 34);
  }
  if (rf & 2) {
    const col_r12 = i0.ɵɵnextContext(2).$implicit;
    const rowData_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("geauiCellRendererComponent", col_r12.renderer.component)("geauiTableId", ctx_r1.tableId)("geauiRowData", rowData_r10)("geauiColumnKey", col_r12.key)("geauiRendererConfig", col_r12.renderer.config);
  }
}
function TableV2Component_p_table_4_ng_template_4_ng_container_1_td_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r12 = i0.ɵɵnextContext(2).$implicit;
    const rowData_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("pTooltip", ctx_r1.displayData(rowData_r10, col_r12.key));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.displayData(rowData_r10, col_r12.key), " ");
  }
}
function TableV2Component_p_table_4_ng_template_4_ng_container_1_td_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 31);
    i0.ɵɵlistener("click", function TableV2Component_p_table_4_ng_template_4_ng_container_1_td_1_Template_td_click_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const col_r12 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.nonClickableColumns.includes(col_r12.key) ? $event.stopPropagation() : null);
    });
    i0.ɵɵtemplate(1, TableV2Component_p_table_4_ng_template_4_ng_container_1_td_1_div_1_Template, 1, 5, "div", 32)(2, TableV2Component_p_table_4_ng_template_4_ng_container_1_td_1_span_2_Template, 2, 2, "span", 33);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    const col_r12 = ctx_r12.$implicit;
    const colIndex_r14 = ctx_r12.index;
    const last_r15 = ctx_r12.last;
    const ctx_r15 = i0.ɵɵnextContext();
    const rowData_r10 = ctx_r15.$implicit;
    const rowgroup_r17 = ctx_r15.rowgroup;
    const rowspan_r18 = ctx_r15.rowspan;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("col-masked-by-clarity-" + col_r12.key);
    i0.ɵɵstyleProp("max-width", ctx_r1.getColWidth(col_r12, colIndex_r14), "px")("min-width", ctx_r1.getColWidth(col_r12, colIndex_r14), "px")("width", ctx_r1.getColWidth(col_r12, colIndex_r14), "px");
    i0.ɵɵproperty("alignFrozen", col_r12.frozen)("frozen", !!col_r12.frozen)("ngClass", i0.ɵɵpureFunction3(15, _c8, col_r12.frozen === "left", col_r12.frozen === "right", ctx_r1.uniquePropertyKey && rowData_r10[ctx_r1.uniquePropertyKey] === ctx_r1.highlightRow && last_r15));
    i0.ɵɵattribute("data-table-column", col_r12.key)("rowspan", rowgroup_r17 && col_r12.rowspan ? rowspan_r18 : null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", col_r12.renderer);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !col_r12.renderer);
  }
}
function TableV2Component_p_table_4_ng_template_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TableV2Component_p_table_4_ng_template_4_ng_container_1_td_1_Template, 3, 19, "td", 30);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const col_r12 = ctx.$implicit;
    const rowgroup_r17 = i0.ɵɵnextContext().rowgroup;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", rowgroup_r17 && col_r12.rowspan || rowgroup_r17 && col_r12.key !== ctx_r1.groupRowsByColumn || !rowgroup_r17 && col_r12.key !== ctx_r1.groupRowsByColumn);
  }
}
function TableV2Component_p_table_4_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 28);
    i0.ɵɵlistener("click", function TableV2Component_p_table_4_ng_template_4_Template_tr_click_0_listener() {
      const rowData_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onRowClicked(rowData_r10));
    })("dblclick", function TableV2Component_p_table_4_ng_template_4_Template_tr_dblclick_0_listener() {
      const rowData_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onRowDoubleClicked(rowData_r10));
    });
    i0.ɵɵtemplate(1, TableV2Component_p_table_4_ng_template_4_ng_container_1_Template, 2, 1, "ng-container", 29);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const rowData_r10 = ctx.$implicit;
    const columns_r19 = ctx.columns;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(2, _c7, ctx_r1.isRowClickable(rowData_r10), ctx_r1.uniquePropertyKey && rowData_r10[ctx_r1.uniquePropertyKey] === ctx_r1.highlightRow, ctx_r1.isStriped && rowData_r10.oddStripingColor));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", columns_r19);
  }
}
function TableV2Component_p_table_4_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "geaui-select-v2", 36);
    i0.ɵɵlistener("selectChanged", function TableV2Component_p_table_4_ng_template_5_Template_geaui_select_v2_selectChanged_3_listener($event) {
      i0.ɵɵrestoreView(_r20);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.pageSizeChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 4, "UI-LIB.TABLE.SHOW"), ":");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("options", ctx_r1.rowsPerPageOptions)("autoDisplayFirst", true)("selected", ctx_r1.pageSize);
  }
}
function TableV2Component_p_table_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-table", 6, 0);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("onLazyLoad", function TableV2Component_p_table_4_Template_p_table_onLazyLoad_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.lazyLoad.emit($event));
    })("onSort", function TableV2Component_p_table_4_Template_p_table_onSort_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSort($event));
    })("onPage", function TableV2Component_p_table_4_Template_p_table_onPage_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.pageChange($event));
    })("selectionChange", function TableV2Component_p_table_4_Template_p_table_selectionChange_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectionChange.emit($event));
    })("pointermove", function TableV2Component_p_table_4_Template_p_table_pointermove_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.resizing($event));
    })("pointerup", function TableV2Component_p_table_4_Template_p_table_pointerup_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.resizeEnd());
    })("mouseleave", function TableV2Component_p_table_4_Template_p_table_mouseleave_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.resizeEnd());
    });
    i0.ɵɵtemplate(3, TableV2Component_p_table_4_ng_template_3_Template, 2, 1, "ng-template", 7)(4, TableV2Component_p_table_4_ng_template_4_Template, 2, 6, "ng-template", 8)(5, TableV2Component_p_table_4_ng_template_5_Template, 4, 6, "ng-template", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("currentPageReportTemplate", "{first}-{last} ", i0.ɵɵpipeBind1(2, 25, "UI-LIB.TABLE.PAGINATION.OF"), " {totalRecords}");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(27, _c0, ctx_r1.data.length === 0, ctx_r1.rowGroupMode, ctx_r1.isStriped, ctx_r1.disableHoverRowEffect))("columns", ctx_r1.visibleColumns)("value", ctx_r1.data)("dataKey", ctx_r1.uniquePropertyKey)("lazy", true)("sortField", ctx_r1.sortColumn)("sortOrder", ctx_r1.sortOrder)("paginator", !!ctx_r1.getTotalRecordsIfBiggerThanPageSize())("showCurrentPageReport", true)("rows", ctx_r1.lazyVirtualScrollPageSize || ctx_r1.filterSettings.pageSize || 10)("first", (ctx_r1.filterSettings.page || 0) * (ctx_r1.filterSettings.pageSize || 10))("totalRecords", ctx_r1.getTotalRecordsIfBiggerThanPageSize())("resizableColumns", false)("scrollable", true)("selectionMode", ctx_r1.selectionMode)("metaKeySelection", false)("selection", ctx_r1.selection)("virtualScroll", ctx_r1.virtualScroll)("virtualScrollItemSize", ctx_r1.virtualScrollItemSize)("virtualScrollOptions", ctx_r1.virtualScrollOptions)("virtualScrollDelay", ctx_r1.virtualScrollDelay)("rowGroupMode", ctx_r1.rowGroupMode)("groupRowsBy", ctx_r1.groupRowsByColumn);
  }
}
function TableV2Component_p_table_5_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "th", 38);
    i0.ɵɵelement(2, "ngx-skeleton-loader", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th", 40);
    i0.ɵɵelement(4, "ngx-skeleton-loader", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th", 41);
    i0.ɵɵelement(6, "ngx-skeleton-loader", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th", 42);
    i0.ɵɵelement(8, "ngx-skeleton-loader", 39);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(4, _c11));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(5, _c11));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(6, _c11));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(7, _c11));
  }
}
function TableV2Component_p_table_5_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 43);
    i0.ɵɵelement(2, "ngx-skeleton-loader", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td", 44);
    i0.ɵɵelement(4, "ngx-skeleton-loader", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 45);
    i0.ɵɵelement(6, "ngx-skeleton-loader", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 46);
    i0.ɵɵelement(8, "ngx-skeleton-loader", 39);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(4, _c11));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(5, _c11));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(6, _c11));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(7, _c11));
  }
}
function TableV2Component_p_table_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p-table", 37);
    i0.ɵɵtemplate(1, TableV2Component_p_table_5_ng_template_1_Template, 9, 8, "ng-template", 7)(2, TableV2Component_p_table_5_ng_template_2_Template, 9, 8, "ng-template", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("value", i0.ɵɵpureFunction4(5, _c10, i0.ɵɵpureFunction0(1, _c9), i0.ɵɵpureFunction0(2, _c9), i0.ɵɵpureFunction0(3, _c9), i0.ɵɵpureFunction0(4, _c9)));
  }
}
function TableV2Component_div_6_geaui_no_entries_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-no-entries", 51);
    i0.ɵɵlistener("actionTriggered", function TableV2Component_div_6_geaui_no_entries_1_Template_geaui_no_entries_actionTriggered_0_listener() {
      i0.ɵɵrestoreView(_r21);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.noEntriesActionTriggered.emit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("titleIcon", ctx_r1.noEntriesTitleIcon)("title", ctx_r1.noEntriesTitle)("infoText", ctx_r1.noEntriesInfoText)("actionText", ctx_r1.noEntriesActionText)("actionIcon", ctx_r1.noEntriesActionIcon);
  }
}
function TableV2Component_div_6_geaui_no_results_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-no-results", 52);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("infoText", ctx_r1.noResultsInfoText);
  }
}
function TableV2Component_div_6_geaui_no_entries_process_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-no-entries-process", 53);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r1.noEntriesProcessPageTitle)("infoText", ctx_r1.noEntriesProcessPageInfoText);
  }
}
function TableV2Component_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵtemplate(1, TableV2Component_div_6_geaui_no_entries_1_Template, 1, 5, "geaui-no-entries", 48)(2, TableV2Component_div_6_geaui_no_results_2_Template, 1, 1, "geaui-no-results", 49)(3, TableV2Component_div_6_geaui_no_entries_process_3_Template, 1, 2, "geaui-no-entries-process", 50);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.hasActiveFilters && ctx_r1.userHasDataAccess && ctx_r1.isLandingPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.hasActiveFilters || !ctx_r1.userHasDataAccess) && ctx_r1.isLandingPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isLandingPage);
  }
}
export class TableV2Component {
  tableService;
  changeDetectorRef;
  // A unique identifier for the table, used to access and save settings and post and receive actions for a specific table
  tableId;
  selectionMode;
  selection = [];
  selectionChange = new EventEmitter();
  // A set of column definitions configuring the columns to display and in what order they are displayed
  columnDefinitions = [];
  // The data to be displayed in the table. Should only contain a single page of data if pagination is active. T is the individual datamodel for this table instance.
  data = [];
  // Setting this value triggers pagination to be active for this table instance. It should contain the total amount of items available for this table.
  // It is then displayed in the pagination and used to correctly display the amount of pages available.
  // The pagination, when activated, only displays when there are more than 10 totalRecords.
  totalRecords;
  // The unique property key has to be a property of the table data <T>. It is used to target specific table rows e.g. for highlighting changes.
  uniquePropertyKey;
  // Defines if the table as a whole has sorting functionality activated.
  sortable = false;
  // Puts the table in a shadow loading state.
  loading = false;
  // Defines if the rows are clickable. If true, hovering a row will show a pointer cursor and clicking it will fire the rowClicked output (or rowDoubleClicked if it was double clicked).
  rowsClickable = false;
  // By default, applies these settings if no other settings are present.
  defaultSettings;
  // Set the value to false to use the table without the striped rows.
  isStriped = true;
  // Set the value to false to disable the hover effect on the rows.
  disableHoverRowEffect = false;
  // Pass the uniquePropertyKey of the row you want to highlight. The row will be highlighted for 5 Seconds.
  // This property is defined as any because row values can be of any type.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  highlightRow;
  // Defines which columns are not clickable. If a column is not clickable, clicking on it will not trigger the rowClicked output.
  nonClickableColumns = [];
  // Defines if you need a special Clickable logic.
  useSpecialClickableLogic = false;
  allowedFileEndings = [];
  // Functions to control the table behaviour.
  tableFunctions = {};
  virtualScroll = false;
  virtualScrollItemSize;
  virtualScrollOptions;
  virtualScrollDelay = 250;
  lazyVirtualScrollPageSize;
  rowGroupMode;
  groupRowsByColumn;
  // Set to true to make the header column double lined
  enableHeaderLineBreaks = false;
  userHasDataAccess = true;
  isLandingPage = false;
  noEntriesTitleIcon = '48px_squares-anim-2';
  noEntriesTitle = 'TABLE.NO-ENTRIES';
  noEntriesInfoText;
  noEntriesActionText;
  noEntriesActionIcon;
  noResultsInfoText;
  noEntriesProcessPageTitle = 'TABLE.NO-ENTRIES-PROCESS-PAGE.TITLE';
  noEntriesProcessPageInfoText = 'TABLE.NO-ENTRIES-PROCESS-PAGE.INFO';
  noEntriesActionTriggered = new EventEmitter();
  // Output that fires when rows are clickable and row is clicked.
  rowClicked = new EventEmitter();
  // Output that fires when rows are clickable and row is double clicked.
  rowDoubleClicked = new EventEmitter();
  // Output that fires when the table is scrolled to the bottom. Used for lazy loading.
  lazyLoad = new EventEmitter();
  // Static values to be displayed in the select input in the pagination to set amount of items per page.
  rowsPerPageOptions = [{
    value: 10,
    name: '10'
  }, {
    value: 20,
    name: '20'
  }, {
    value: 30,
    name: '30'
  }, {
    value: 40,
    name: '40'
  }, {
    value: 50,
    name: '50'
  }];
  // The filter settings that will be received from the table service.
  filterSettings = {
    columns: {}
  };
  // The column settings that will be received from the table service.
  columnSettings = {
    columns: {}
  };
  // The column that is currently being sorted. Will be set according to the filter settings received from the table service.
  sortColumn = '';
  // The currently active sort order. Will be set according to the filter settings received from the table service.
  sortOrder;
  // The column definitions used by the table containing all columns that are not hidden.
  visibleColumns = [];
  // Used in the logic that distinguishes single click from double click.
  singleClick = false;
  // The subscription to the filter settings in the table service.
  filterSettingsSubscription;
  // The subscription to the column settings in the table service.
  columnSettingsSubscription;
  // The sort direction enum to be used in the template.
  SortDirection = SortDirection;
  pageSize = {
    name: '10',
    value: 10
  };
  hasActiveFilters = false;
  isResizing = false;
  resizeStartValue = 0;
  resizingColumnKey = '';
  resizingColumnWidth = 0;
  constructor(tableService, changeDetectorRef) {
    this.tableService = tableService;
    this.changeDetectorRef = changeDetectorRef;
  }
  ngOnChanges(changes) {
    if (changes['loading']?.currentValue === false) {
      this.startHighlightCountdown();
    }
    if (changes['highlightRow']?.currentValue && !this.loading) {
      this.startHighlightCountdown();
    }
    if (changes['columnDefinitions']?.currentValue) {
      this.initVisibleTableColumns();
    }
    if (this.columnDefinitions?.length && this.tableId && !this.columnSettingsSubscription) {
      this.initColumnTableSettings();
    }
  }
  startHighlightCountdown() {
    if (this.highlightRow) {
      setTimeout(() => {
        this.highlightRow = undefined;
      }, 5000);
    }
  }
  resizeStart(e, colKey) {
    const column = this.columnDefinitions.find(colDef => colDef.key === colKey);
    if (!this.tableId || column?.resizeable === false) return;
    // Get initial width of the column that is being resized.
    const columnHeader = document.getElementById(colKey);
    if (columnHeader) {
      this.resizingColumnWidth = columnHeader.clientWidth;
    }
    // In case the second to last column was resized before and therefor has width values set in the style, we have to remove them if another column is resized to make the second to last column variable again.
    const colIndex = this.visibleColumns?.findIndex(colDef => colDef.key === colKey);
    const isSecondToLastColumn = colIndex === this.visibleColumns.length - 2;
    if (!isSecondToLastColumn) {
      const secondToLastColumn = this.visibleColumns[this.visibleColumns.length - 2];
      const element = document.getElementById(secondToLastColumn.key);
      const rows = document.querySelectorAll('[data-table-column="' + this.resizingColumnKey + '"]');
      if (element && rows) {
        element.style.width = '';
        element.style.maxWidth = '';
        rows.forEach(row => {
          row.style.width = '';
          row.style.maxWidth = '';
        });
      }
    }
    this.isResizing = true;
    this.resizeStartValue = e.x;
    this.resizingColumnKey = colKey;
    e.stopPropagation();
  }
  resizing(e) {
    if (this.isResizing) {
      this.resizingColumnWidth = this.resizingColumnWidth + (e.x - this.resizeStartValue);
      const colIndex = this.visibleColumns?.findIndex(colDef => colDef.key === this.resizingColumnKey);
      const isSecondToLastColumn = colIndex === this.visibleColumns.length - 2;
      // The second to last column is variable in size and therefor behaves differently than the other columns.
      if (isSecondToLastColumn) {
        this.resizeSecondToLastColumn(e);
      } else {
        this.columnSettings.columns[this.resizingColumnKey].width = this.resizingColumnWidth;
      }
      this.resizeStartValue = e.x;
    }
    e.stopPropagation();
  }
  resizeSecondToLastColumn(e) {
    // Since the value is variable and not stored in the settings, we have to work with the actual HTML elements.
    const columnHeader = document.getElementById(this.resizingColumnKey);
    const columnRows = document.querySelectorAll('[data-table-column="' + this.resizingColumnKey + '"]');
    if (columnHeader && columnRows) {
      // There is special behaviour needed if the second to last column shrinks so much, that the row would grow shorter than the table if no adjustments were made.
      if (e.x - this.resizeStartValue < 0) {
        // To catch this case, we need to access additional HTML elements.
        const tableContainer = document.getElementsByClassName('p-datatable-wrapper');
        let viewportWidth = 0;
        if (tableContainer[0]) {
          viewportWidth = tableContainer[0].clientWidth;
        }
        const rowSize = columnHeader.parentElement?.clientWidth ?? 0;
        // If the row size does shrink below the container width, we adjust the third to last column to compensate and avoid the table from shrinking.
        const thirdToLastColumn = this.visibleColumns[this.visibleColumns.length - 3];
        if (rowSize + (e.x - this.resizeStartValue) < viewportWidth) {
          this.columnSettings.columns[thirdToLastColumn.key].width = (this.columnSettings.columns[thirdToLastColumn.key].width ?? 150) - (e.x - this.resizeStartValue);
        }
      }
      columnHeader.style.width = this.resizingColumnWidth + 'px';
      columnHeader.style.maxWidth = this.resizingColumnWidth + 'px';
      columnRows.forEach(row => {
        row.style.width = this.resizingColumnWidth + 'px';
        row.style.maxWidth = this.resizingColumnWidth + 'px';
      });
    }
  }
  resizeEnd() {
    if (!this.isResizing) return;
    // When resizing the second to last column, the cursor might leave the resize handler and will trigger a click event after resizing, triggering the sort function. To avoid this, setting isResizing to false is delayed.
    setTimeout(() => {
      this.isResizing = false;
    }, 100);
    if (this.tableId) {
      this.tableService.updateColumnTableSettings(this.tableId, this.columnSettings);
    }
  }
  filterOpenChanged(open, col) {
    if (!col.filter) return;
    if (open !== col.filter?.open) {
      col.filter.open = open;
    }
    // If this was called because of a filter closing, updating the value is all that is needed.
    if (!open) return;
    // If a filter was opened, all other filters must be closed as only one filter is allowed to be open at a time.
    this.visibleColumns.forEach(column => {
      if (column.filter) column.filter.open = column.key === col.key;
    });
  }
  initVisibleTableColumns() {
    // Among other things, the column settings received from the table service contain information about the visibility of the table columns.
    // If column settings are already present, they are used to filter out the columns that are hidden.
    // The table will only display the columns in the visibleColumns property.<
    if (this.columnSettings) {
      this.visibleColumns = sortColumnDefinitions(this.columnDefinitions.filter(colDef => this.columnSettings.columns[colDef.key]?.visible !== false), this.columnSettings);
    } else {
      // If no column settings are available, all columns are set as visible for now
      this.visibleColumns = this.columnDefinitions;
    }
  }
  initColumnTableSettings() {
    // Table ID is required for settings logic.
    if (!this.tableId) return;
    // The backend expects both width and visible properties to be set for all columns present in the settings,
    // so we prepare default settings with defaults for all values for all columns.
    const initialColumnSettings = this.columnDefinitions.map(column => ({
      [column.key]: {
        width: column.width ?? 150,
        visible: column.visible ?? true
      }
    })).reduce((prev, curr) => ({
      ...prev,
      ...curr
    }), {});
    // Initialize and subscribe to the column settings in the table service.
    this.columnSettingsSubscription = this.tableService.getOrInitializeColumnTableSettings(this.tableId, {
      columns: initialColumnSettings,
      pageSize: 10
    }).subscribe(settings => this.applyColumnTableSettings(settings));
  }
  // Returns the totalRecords if the totalRecords are larger than the default page size. Used for the pagination.
  getTotalRecordsIfBiggerThanPageSize() {
    const defaultPageSize = 10;
    if (this.totalRecords !== undefined && this.totalRecords > defaultPageSize) {
      return this.totalRecords;
    }
    return undefined;
  }
  onSort(event) {
    if (this.isResizing || !this.tableId || !this.sortable) return;
    const sessionTableSettings = {
      columns: {}
    };
    // Only one colum can be sorted at a time, so only the most recently sorted column remains sorted, for all other columns sorting is removed.
    this.columnDefinitions?.forEach(column => {
      if (column.key === event.field) {
        sessionTableSettings.columns[column.key] = {
          sort: event.order === 1 ? SortDirection.ASCENDING : SortDirection.DESCENDING
        };
      } else {
        sessionTableSettings.columns[column.key] = {
          sort: SortDirection.NONE
        };
      }
    });
    // Updated filter settings are pushed to the table service.
    this.tableService.updateFilterTableSettings(this.tableId, sessionTableSettings);
  }
  pageSizeChange(size) {
    if (!this.tableId) return;
    // New page size is sent to table service and current page is set to 0.
    this.tableService.updateFilterTableSettings(this.tableId, {
      columns: {},
      // We know this property exists here
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      pageSize: size.value,
      page: 0
    });
  }
  pageChange(event) {
    if (!this.tableId) return;
    // The new page is sent to the table service.
    this.tableService.updateFilterTableSettings(this.tableId, {
      columns: {},
      page: event.first / event.rows
    });
  }
  onRowClicked(rowData) {
    const isRowClickable = this.tableFunctions?.rowsClickableFunction ? this.tableFunctions?.rowsClickableFunction(rowData) : this.rowsClickable;
    // If the rows are clickable, ensure it is a single click only with help of a timeout.
    if (isRowClickable) {
      this.singleClick = true;
      setTimeout(() => {
        if (this.singleClick) {
          this.rowClicked.emit(rowData);
        }
      }, 250);
    }
  }
  isRowClickable(rowData) {
    if (this.tableFunctions?.rowsClickableFunction) {
      return this.tableFunctions?.rowsClickableFunction(rowData);
    }
    if (!this.useSpecialClickableLogic) {
      return this.rowsClickable;
    } else {
      return this.rowsClickable && (this.allowedFileEndings.includes(rowData.fileEnding) || rowData.resourceType === 'directory');
    }
  }
  onRowDoubleClicked(rowData) {
    const isRowClickable = this.tableFunctions?.rowsClickableFunction ? this.tableFunctions?.rowsClickableFunction(rowData) : this.rowsClickable;
    // If the rows are clickable and a double click event was triggered, make sure no single click event is emitted.
    if (isRowClickable) {
      this.singleClick = false;
      this.rowDoubleClicked.emit(rowData);
    }
  }
  displayData(rowData, key) {
    // Calls a helper function that allows for nested values to be used as data keys and returns the data to be displayed in the table.
    return getNestedValue(rowData, key);
  }
  getColWidth(col, colIndex) {
    const savedWidth = this.columnSettings.columns[col.key]?.width;
    let savedWidthToUse;
    if (savedWidth) {
      savedWidthToUse = col.minWidth && savedWidth < col.minWidth ? col.minWidth : savedWidth;
    }
    // Only use the saved value if it is larger than 1 and if the column is not the second to last column
    return colIndex === this.visibleColumns.length - 2 || savedWidth === 1 ? col.minWidth ?? '' : savedWidthToUse;
  }
  initDefaultFilterSettings() {
    // If default filter settings are present, they are sent to the table service.
    if (!this.defaultSettings) return;
    if (this.tableId) this.tableService.updateFilterTableSettings(this.tableId, this.defaultSettings);
  }
  applyFilterTableSettings(settings) {
    // This function is called when the table service emmits new filter table settings.
    // The filter table settings are cached in the component.
    this.filterSettings = settings;
    // pageSize has to be kept in sync between FilterTableSettings and ColumnTableSettings
    if (settings.pageSize && settings.pageSize !== this.columnSettings.pageSize && this.tableId) {
      this.tableService.updateColumnTableSettings(this.tableId, {
        columns: {},
        pageSize: settings.pageSize
      });
    }
    this.hasActiveFilters = !!this.filterSettings.search || !!this.filterSettings.searchValue || !!this.filterSettings.multiSelectFilter?.length || !!this.filterSettings.toggleFilter || !!Object.keys(this.filterSettings.columns).some(key => this.filterSettings.columns[key].filter?.length);
    // Then any settings that don't get read directly from the cache, in this case sorting, are applied here.
    Object.keys(this.filterSettings.columns).forEach(columnKey => {
      if (this.filterSettings.columns[columnKey].sort) {
        this.sortColumn = columnKey;
        this.sortOrder = this.filterSettings.columns[columnKey].sort === SortDirection.ASCENDING ? 1 : -1;
      }
    });
  }
  applyColumnTableSettings(settings) {
    if (!settings) return;
    this.columnSettings = settings;
    // Setting up FilterTableSettings happens depending on the ColumnTableSettings. This is because the single source of truth for the page size lies in the ColumnTableSettings. It is also exposed through the FilterTableSettings for easier use.
    if (!this.filterSettingsSubscription && this.tableId) {
      if (!this.tableService.isActiveSessionForTable(this.tableId)) this.initDefaultFilterSettings();
      if (settings.pageSize) {
        this.tableService.updateFilterTableSettings(this.tableId, {
          columns: {},
          pageSize: settings.pageSize
        });
      }
      // Initialize and subscribe to the filter settings in the table service.
      this.filterSettingsSubscription = this.tableService.getFilterTableSettings(this.tableId).subscribe(settings => this.applyFilterTableSettings(settings));
    } else if (settings.pageSize && settings.pageSize !== this.filterSettings.pageSize && this.tableId) {
      this.tableService.updateFilterTableSettings(this.tableId, {
        columns: {},
        pageSize: settings.pageSize
      });
    }
    if (this.columnSettings.pageSize) {
      this.pageSize = {
        name: this.columnSettings.pageSize.toString(),
        value: this.columnSettings.pageSize
      };
    }
    this.visibleColumns = sortColumnDefinitions(this.columnDefinitions.filter(colDef => this.columnSettings.columns[colDef.key]?.visible !== false), this.columnSettings);
    this.changeDetectorRef.detectChanges();
  }
  ngOnDestroy() {
    this.columnSettingsSubscription?.unsubscribe();
    this.filterSettingsSubscription?.unsubscribe();
  }
  static ɵfac = function TableV2Component_Factory(t) {
    return new (t || TableV2Component)(i0.ɵɵdirectiveInject(i1.TableServiceV2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TableV2Component,
    selectors: [["geaui-table-v2"]],
    inputs: {
      tableId: "tableId",
      selectionMode: "selectionMode",
      selection: "selection",
      columnDefinitions: "columnDefinitions",
      data: "data",
      totalRecords: "totalRecords",
      uniquePropertyKey: "uniquePropertyKey",
      sortable: "sortable",
      loading: "loading",
      rowsClickable: "rowsClickable",
      defaultSettings: "defaultSettings",
      isStriped: "isStriped",
      disableHoverRowEffect: "disableHoverRowEffect",
      highlightRow: "highlightRow",
      nonClickableColumns: "nonClickableColumns",
      useSpecialClickableLogic: "useSpecialClickableLogic",
      allowedFileEndings: "allowedFileEndings",
      tableFunctions: "tableFunctions",
      virtualScroll: "virtualScroll",
      virtualScrollItemSize: "virtualScrollItemSize",
      virtualScrollOptions: "virtualScrollOptions",
      virtualScrollDelay: "virtualScrollDelay",
      lazyVirtualScrollPageSize: "lazyVirtualScrollPageSize",
      rowGroupMode: "rowGroupMode",
      groupRowsByColumn: "groupRowsByColumn",
      enableHeaderLineBreaks: "enableHeaderLineBreaks",
      userHasDataAccess: "userHasDataAccess",
      isLandingPage: "isLandingPage",
      noEntriesTitleIcon: "noEntriesTitleIcon",
      noEntriesTitle: "noEntriesTitle",
      noEntriesInfoText: "noEntriesInfoText",
      noEntriesActionText: "noEntriesActionText",
      noEntriesActionIcon: "noEntriesActionIcon",
      noResultsInfoText: "noResultsInfoText",
      noEntriesProcessPageTitle: "noEntriesProcessPageTitle",
      noEntriesProcessPageInfoText: "noEntriesProcessPageInfoText"
    },
    outputs: {
      selectionChange: "selectionChange",
      noEntriesActionTriggered: "noEntriesActionTriggered",
      rowClicked: "rowClicked",
      rowDoubleClicked: "rowDoubleClicked",
      lazyLoad: "lazyLoad"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 7,
    vars: 6,
    consts: [["datatable", ""], [1, "switch-landscape-overlay"], [1, "switch-landscape-message"], ["class", "geaui-table-blurred geaui-table-loaded", "columnResizeMode", "expand", "scrollHeight", "flex", "data-cy", "table", 3, "ngClass", "columns", "value", "dataKey", "lazy", "sortField", "sortOrder", "paginator", "showCurrentPageReport", "rows", "first", "totalRecords", "resizableColumns", "scrollable", "selectionMode", "metaKeySelection", "selection", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "virtualScrollDelay", "rowGroupMode", "groupRowsBy", "currentPageReportTemplate", "onLazyLoad", "onSort", "onPage", "selectionChange", "pointermove", "pointerup", "mouseleave", 4, "ngIf"], [3, "value", 4, "ngIf"], ["class", "no-data-container", 4, "ngIf"], ["columnResizeMode", "expand", "scrollHeight", "flex", "data-cy", "table", 1, "geaui-table-blurred", "geaui-table-loaded", 3, "onLazyLoad", "onSort", "onPage", "selectionChange", "pointermove", "pointerup", "mouseleave", "ngClass", "columns", "value", "dataKey", "lazy", "sortField", "sortOrder", "paginator", "showCurrentPageReport", "rows", "first", "totalRecords", "resizableColumns", "scrollable", "selectionMode", "metaKeySelection", "selection", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "virtualScrollDelay", "rowGroupMode", "groupRowsBy", "currentPageReportTemplate"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "paginatorright"], ["pResizableColumn", "", "pFrozenColumn", "", "data-cy", "table-header", 3, "pSortableColumn", "pSortableColumnDisabled", "alignFrozen", "frozen", "id", "width", "maxWidth", "minWidth", "ngClass", 4, "ngFor", "ngForOf"], ["pResizableColumn", "", "pFrozenColumn", "", "data-cy", "table-header", 3, "pSortableColumn", "pSortableColumnDisabled", "alignFrozen", "frozen", "id", "ngClass"], [1, "header-content"], [3, "ngClass"], [3, "geauiFilterRendererComponent", "geauiColumnKey", "geauiColumnName", "geauiRendererConfig", "geauiTableId", "geauiFilterOpen", "geauiFilterOpenChange", 4, "ngIf"], [3, "geauiHeaderRendererComponent", "geauiTableId", "geauiDisplayName", "geauiRendererConfig", 4, "ngIf"], ["class", "header-text ellipsis", "geauiTooltipOnEllipsisV2", "", 3, "ngClass", "pTooltip", 4, "ngIf"], [1, "sort-icon-container"], ["color", "none", "file", "16px__sort", 3, "clickable", "ngClass", 4, "ngIf"], ["class", "filter-icon-container", 3, "click", 4, "ngIf"], ["class", "resizer", 3, "ngClass", "click", "pointerdown", 4, "ngIf"], [3, "geauiFilterOpenChange", "geauiFilterRendererComponent", "geauiColumnKey", "geauiColumnName", "geauiRendererConfig", "geauiTableId", "geauiFilterOpen"], [3, "geauiHeaderRendererComponent", "geauiTableId", "geauiDisplayName", "geauiRendererConfig"], ["geauiTooltipOnEllipsisV2", "", 1, "header-text", "ellipsis", 3, "ngClass", "pTooltip"], ["color", "none", "file", "16px__sort", 3, "clickable", "ngClass"], [1, "filter-icon-container", 3, "click"], ["color", "black", "file", "16px_system-preferences", 1, "filter-icon", 3, "clickable", "ngClass"], [1, "resizer", 3, "click", "pointerdown", "ngClass"], ["data-cy", "table-row", 3, "click", "dblclick", "ngClass"], [4, "ngFor", "ngForOf"], ["pFrozenColumn", "", 3, "alignFrozen", "frozen", "maxWidth", "minWidth", "width", "ngClass", "class", "click", 4, "ngIf"], ["pFrozenColumn", "", 3, "click", "alignFrozen", "frozen", "ngClass"], [3, "geauiCellRendererComponent", "geauiTableId", "geauiRowData", "geauiColumnKey", "geauiRendererConfig", 4, "ngIf"], ["class", "ellipsis", "geauiTooltipOnEllipsisV2", "", 3, "pTooltip", 4, "ngIf"], [3, "geauiCellRendererComponent", "geauiTableId", "geauiRowData", "geauiColumnKey", "geauiRendererConfig"], ["geauiTooltipOnEllipsisV2", "", 1, "ellipsis", 3, "pTooltip"], [3, "selectChanged", "options", "autoDisplayFirst", "selected"], [3, "value"], ["id", "loader1"], ["count", "1", "appearance", "line", 3, "theme"], ["id", "loader2"], ["id", "loader3"], ["id", "loader4"], [1, "loader-1"], [1, "loader-2"], [1, "loader-3"], [1, "loader-4"], [1, "no-data-container"], [3, "titleIcon", "title", "infoText", "actionText", "actionIcon", "actionTriggered", 4, "ngIf"], [3, "infoText", 4, "ngIf"], [3, "title", "infoText", 4, "ngIf"], [3, "actionTriggered", "titleIcon", "title", "infoText", "actionText", "actionIcon"], [3, "infoText"], [3, "title", "infoText"]],
    template: function TableV2Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(4, TableV2Component_p_table_4_Template, 6, 32, "p-table", 3)(5, TableV2Component_p_table_5_Template, 3, 10, "p-table", 4)(6, TableV2Component_div_6_Template, 4, 3, "div", 5);
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "UI-LIB.TABLE.SWITCH_LANDSCAPE"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", (!ctx.data || !ctx.data.length) && !ctx.loading);
      }
    },
    dependencies: [i2.Table, i3.PrimeTemplate, i2.SortableColumn, i2.FrozenColumn, i2.ResizableColumn, i4.NgClass, i4.NgForOf, i4.NgIf, i5.IconComponent, i6.TooltipOnEllipsisV2Directive, i7.SelectV2Component, i8.NgxSkeletonLoaderComponent, i9.Tooltip, i10.ComponentRendererV2Directive, i11.HeaderRendererV2Directive, i12.FilterRendererDirective, i13.NoEntriesComponent, i14.NoResultsComponent, i15.NoEntriesProcessComponent, i16.TranslatePipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableV2Component, [{
    type: Component,
    args: [{
      selector: 'geaui-table-v2',
      template: "<div class=\"switch-landscape-overlay\">\n  <div class=\"switch-landscape-message\">{{ 'UI-LIB.TABLE.SWITCH_LANDSCAPE' | translate }}</div>\n</div>\n<p-table\n  class=\"geaui-table-blurred geaui-table-loaded\"\n  #datatable\n  *ngIf=\"!loading\"\n  [ngClass]=\"{\n    'no-data': data.length === 0,\n    rowspan: rowGroupMode,\n    'p-datatable-striped': isStriped,\n    'disable-hover-row-effect': disableHoverRowEffect,\n  }\"\n  [columns]=\"visibleColumns\"\n  [value]=\"data\"\n  [dataKey]=\"uniquePropertyKey\"\n  [lazy]=\"true\"\n  [sortField]=\"sortColumn\"\n  [sortOrder]=\"sortOrder\"\n  [paginator]=\"!!getTotalRecordsIfBiggerThanPageSize()\"\n  [showCurrentPageReport]=\"true\"\n  [rows]=\"lazyVirtualScrollPageSize || filterSettings.pageSize || 10\"\n  [first]=\"(filterSettings.page || 0) * (filterSettings.pageSize || 10)\"\n  [totalRecords]=\"getTotalRecordsIfBiggerThanPageSize()\"\n  [resizableColumns]=\"false\"\n  [scrollable]=\"true\"\n  [selectionMode]=\"selectionMode\"\n  [metaKeySelection]=\"false\"\n  [selection]=\"selection\"\n  [virtualScroll]=\"virtualScroll\"\n  [virtualScrollItemSize]=\"virtualScrollItemSize\"\n  [virtualScrollOptions]=\"virtualScrollOptions\"\n  [virtualScrollDelay]=\"virtualScrollDelay\"\n  [rowGroupMode]=\"rowGroupMode\"\n  [groupRowsBy]=\"groupRowsByColumn\"\n  (onLazyLoad)=\"lazyLoad.emit($event)\"\n  (onSort)=\"onSort($event)\"\n  (onPage)=\"pageChange($event)\"\n  (selectionChange)=\"selectionChange.emit($event)\"\n  (pointermove)=\"resizing($event)\"\n  (pointerup)=\"resizeEnd()\"\n  (mouseleave)=\"resizeEnd()\"\n  currentPageReportTemplate=\"{first}-{last} {{ 'UI-LIB.TABLE.PAGINATION.OF' | translate }} {totalRecords}\"\n  columnResizeMode=\"expand\"\n  scrollHeight=\"flex\"\n  data-cy=\"table\">\n  <ng-template pTemplate=\"header\" let-columns>\n    <tr>\n      <th\n        *ngFor=\"let col of columns; let colIndex = index\"\n        [pSortableColumn]=\"sortable ? col.key : undefined\"\n        [pSortableColumnDisabled]=\"col.sortable === false || !sortable\"\n        [alignFrozen]=\"col.frozen\"\n        [frozen]=\"!!col.frozen\"\n        [id]=\"col.key\"\n        [style.width.px]=\"getColWidth(col, colIndex)\"\n        [style.maxWidth.px]=\"getColWidth(col, colIndex)\"\n        [style.minWidth.px]=\"col.minWidth\"\n        [ngClass]=\"{\n          'sticky-left': col.frozen === 'left',\n          'sticky-right': col.frozen === 'right',\n        }\"\n        pResizableColumn\n        pFrozenColumn\n        data-cy=\"table-header\">\n        <div class=\"header-content\">\n          <div [ngClass]=\"{ 'left-header': !col.headerRenderer }\">\n            <div\n              *ngIf=\"col.filter\"\n              [geauiFilterRendererComponent]=\"col.filter.component\"\n              [geauiColumnKey]=\"col.key\"\n              [geauiColumnName]=\"col.displayName | translate\"\n              [geauiRendererConfig]=\"col.filter.config\"\n              [geauiTableId]=\"tableId\"\n              [geauiFilterOpen]=\"col.filter.open\"\n              (geauiFilterOpenChange)=\"filterOpenChanged($event, col)\"></div>\n            <div\n              *ngIf=\"col.headerRenderer\"\n              [geauiHeaderRendererComponent]=\"col.headerRenderer.component\"\n              [geauiTableId]=\"tableId\"\n              [geauiDisplayName]=\"col.displayName\"\n              [geauiRendererConfig]=\"col.headerRenderer.config\"></div>\n            <span\n              class=\"header-text ellipsis\"\n              *ngIf=\"!col.headerRenderer\"\n              [ngClass]=\"{ 'header-linebreaks': enableHeaderLineBreaks }\"\n              [pTooltip]=\"col.displayName | translate\"\n              geauiTooltipOnEllipsisV2>\n              {{ col.displayName | translate }}\n            </span>\n          </div>\n          <div class=\"sort-icon-container\">\n            <geaui-icon-v2\n              *ngIf=\"col.sortable !== false && sortable\"\n              [clickable]=\"true\"\n              [ngClass]=\"{\n                isSorted: filterSettings.columns[col.key]?.sort,\n                asc: filterSettings.columns[col.key]?.sort === SortDirection.ASCENDING,\n                desc: filterSettings.columns[col.key]?.sort === SortDirection.DESCENDING,\n              }\"\n              color=\"none\"\n              file=\"16px__sort\">\n            </geaui-icon-v2>\n          </div>\n          <div\n            class=\"filter-icon-container\"\n            *ngIf=\"col.filter\"\n            (click)=\"$event.stopPropagation(); filterOpenChanged(!col.filter.open, col)\">\n            <geaui-icon-v2\n              class=\"filter-icon\"\n              [clickable]=\"true\"\n              [ngClass]=\"{\n                'filter-active':\n                  filterSettings.columns[col.key]?.filter?.length > 0 && filterSettings.columns[col.key]?.filter[0],\n              }\"\n              color=\"black\"\n              file=\"16px_system-preferences\">\n            </geaui-icon-v2>\n          </div>\n          <div\n            class=\"resizer\"\n            *ngIf=\"colIndex !== visibleColumns.length - 1\"\n            [ngClass]=\"{ 'no-resize': col.resizeable === false || !tableId }\"\n            (click)=\"$event.stopPropagation()\"\n            (pointerdown)=\"resizeStart($event, col.key)\">\n            <span></span>\n          </div>\n        </div>\n      </th>\n    </tr>\n  </ng-template>\n  <ng-template\n    pTemplate=\"body\"\n    let-rowData\n    let-columns=\"columns\"\n    let-ri=\"rowIndex\"\n    let-element\n    let-expanded=\"expanded\"\n    let-rowgroup=\"rowgroup\"\n    let-rowspan=\"rowspan\">\n    <tr\n      [ngClass]=\"{\n        clickable: isRowClickable(rowData),\n        highlight: uniquePropertyKey && rowData[uniquePropertyKey] === highlightRow,\n        'odd-striping-color': isStriped && rowData.oddStripingColor,\n      }\"\n      (click)=\"onRowClicked(rowData)\"\n      (dblclick)=\"onRowDoubleClicked(rowData)\"\n      data-cy=\"table-row\">\n      <ng-container *ngFor=\"let col of columns; let colIndex = index; let last = last\">\n        <td\n          *ngIf=\"\n            (rowgroup && col.rowspan) ||\n            (rowgroup && col.key !== groupRowsByColumn) ||\n            (!rowgroup && col.key !== groupRowsByColumn)\n          \"\n          [attr.data-table-column]=\"col.key\"\n          [attr.rowspan]=\"rowgroup && col.rowspan ? rowspan : null\"\n          [alignFrozen]=\"col.frozen\"\n          [frozen]=\"!!col.frozen\"\n          [style.maxWidth.px]=\"getColWidth(col, colIndex)\"\n          [style.minWidth.px]=\"getColWidth(col, colIndex)\"\n          [style.width.px]=\"getColWidth(col, colIndex)\"\n          [ngClass]=\"{\n            'sticky-left': col.frozen === 'left',\n            'sticky-right': col.frozen === 'right',\n            'highlight-right': uniquePropertyKey && rowData[uniquePropertyKey] === highlightRow && last,\n          }\"\n          [class]=\"'col-masked-by-clarity-' + col.key\"\n          (click)=\"nonClickableColumns.includes(col.key) ? $event.stopPropagation() : null\"\n          pFrozenColumn>\n          <div\n            *ngIf=\"col.renderer\"\n            [geauiCellRendererComponent]=\"col.renderer.component\"\n            [geauiTableId]=\"tableId\"\n            [geauiRowData]=\"rowData\"\n            [geauiColumnKey]=\"col.key\"\n            [geauiRendererConfig]=\"col.renderer.config\"></div>\n          <span class=\"ellipsis\" *ngIf=\"!col.renderer\" [pTooltip]=\"displayData(rowData, col.key)\" geauiTooltipOnEllipsisV2>\n            {{ displayData(rowData, col.key) }}\n          </span>\n        </td>\n      </ng-container>\n    </tr>\n  </ng-template>\n\n  <ng-template pTemplate=\"paginatorright\">\n    <span>{{ 'UI-LIB.TABLE.SHOW' | translate }}:</span>\n    <geaui-select-v2\n      [options]=\"rowsPerPageOptions\"\n      [autoDisplayFirst]=\"true\"\n      [selected]=\"pageSize\"\n      (selectChanged)=\"pageSizeChange($event)\">\n    </geaui-select-v2>\n  </ng-template>\n</p-table>\n<p-table *ngIf=\"loading\" [value]=\"[{}, {}, {}, {}]\">\n  <ng-template pTemplate=\"header\">\n    <tr>\n      <th id=\"loader1\">\n        <ngx-skeleton-loader\n          [theme]=\"{ height: '25px', width: '100%', 'margin-bottom': 0 }\"\n          count=\"1\"\n          appearance=\"line\"></ngx-skeleton-loader>\n      </th>\n      <th id=\"loader2\">\n        <ngx-skeleton-loader\n          [theme]=\"{ height: '25px', width: '100%', 'margin-bottom': 0 }\"\n          count=\"1\"\n          appearance=\"line\"></ngx-skeleton-loader>\n      </th>\n      <th id=\"loader3\">\n        <ngx-skeleton-loader\n          [theme]=\"{ height: '25px', width: '100%', 'margin-bottom': 0 }\"\n          count=\"1\"\n          appearance=\"line\"></ngx-skeleton-loader>\n      </th>\n      <th id=\"loader4\">\n        <ngx-skeleton-loader\n          [theme]=\"{ height: '25px', width: '100%', 'margin-bottom': 0 }\"\n          count=\"1\"\n          appearance=\"line\"></ngx-skeleton-loader>\n      </th>\n    </tr>\n  </ng-template>\n  <ng-template pTemplate=\"body\">\n    <tr>\n      <td class=\"loader-1\">\n        <ngx-skeleton-loader\n          [theme]=\"{ height: '25px', width: '100%', 'margin-bottom': 0 }\"\n          count=\"1\"\n          appearance=\"line\"></ngx-skeleton-loader>\n      </td>\n      <td class=\"loader-2\">\n        <ngx-skeleton-loader\n          [theme]=\"{ height: '25px', width: '100%', 'margin-bottom': 0 }\"\n          count=\"1\"\n          appearance=\"line\"></ngx-skeleton-loader>\n      </td>\n      <td class=\"loader-3\">\n        <ngx-skeleton-loader\n          [theme]=\"{ height: '25px', width: '100%', 'margin-bottom': 0 }\"\n          count=\"1\"\n          appearance=\"line\"></ngx-skeleton-loader>\n      </td>\n      <td class=\"loader-4\">\n        <ngx-skeleton-loader\n          [theme]=\"{ height: '25px', width: '100%', 'margin-bottom': 0 }\"\n          count=\"1\"\n          appearance=\"line\"></ngx-skeleton-loader>\n      </td>\n    </tr>\n  </ng-template>\n</p-table>\n<div class=\"no-data-container\" *ngIf=\"(!data || !data.length) && !loading\">\n  <geaui-no-entries\n    *ngIf=\"!hasActiveFilters && userHasDataAccess && isLandingPage\"\n    [titleIcon]=\"noEntriesTitleIcon\"\n    [title]=\"noEntriesTitle\"\n    [infoText]=\"noEntriesInfoText\"\n    [actionText]=\"noEntriesActionText\"\n    [actionIcon]=\"noEntriesActionIcon\"\n    (actionTriggered)=\"noEntriesActionTriggered.emit()\"></geaui-no-entries>\n  <geaui-no-results\n    *ngIf=\"(hasActiveFilters || !userHasDataAccess) && isLandingPage\"\n    [infoText]=\"noResultsInfoText\"></geaui-no-results>\n  <geaui-no-entries-process\n    *ngIf=\"!isLandingPage\"\n    [title]=\"noEntriesProcessPageTitle\"\n    [infoText]=\"noEntriesProcessPageInfoText\"></geaui-no-entries-process>\n</div>\n"
    }]
  }], () => [{
    type: i1.TableServiceV2
  }, {
    type: i0.ChangeDetectorRef
  }], {
    tableId: [{
      type: Input
    }],
    selectionMode: [{
      type: Input
    }],
    selection: [{
      type: Input
    }],
    selectionChange: [{
      type: Output
    }],
    columnDefinitions: [{
      type: Input
    }],
    data: [{
      type: Input
    }],
    totalRecords: [{
      type: Input
    }],
    uniquePropertyKey: [{
      type: Input
    }],
    sortable: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    rowsClickable: [{
      type: Input
    }],
    defaultSettings: [{
      type: Input
    }],
    isStriped: [{
      type: Input
    }],
    disableHoverRowEffect: [{
      type: Input
    }],
    highlightRow: [{
      type: Input
    }],
    nonClickableColumns: [{
      type: Input
    }],
    useSpecialClickableLogic: [{
      type: Input
    }],
    allowedFileEndings: [{
      type: Input
    }],
    tableFunctions: [{
      type: Input
    }],
    virtualScroll: [{
      type: Input
    }],
    virtualScrollItemSize: [{
      type: Input
    }],
    virtualScrollOptions: [{
      type: Input
    }],
    virtualScrollDelay: [{
      type: Input
    }],
    lazyVirtualScrollPageSize: [{
      type: Input
    }],
    rowGroupMode: [{
      type: Input
    }],
    groupRowsByColumn: [{
      type: Input
    }],
    enableHeaderLineBreaks: [{
      type: Input
    }],
    userHasDataAccess: [{
      type: Input
    }],
    isLandingPage: [{
      type: Input
    }],
    noEntriesTitleIcon: [{
      type: Input
    }],
    noEntriesTitle: [{
      type: Input
    }],
    noEntriesInfoText: [{
      type: Input
    }],
    noEntriesActionText: [{
      type: Input
    }],
    noEntriesActionIcon: [{
      type: Input
    }],
    noResultsInfoText: [{
      type: Input
    }],
    noEntriesProcessPageTitle: [{
      type: Input
    }],
    noEntriesProcessPageInfoText: [{
      type: Input
    }],
    noEntriesActionTriggered: [{
      type: Output
    }],
    rowClicked: [{
      type: Output
    }],
    rowDoubleClicked: [{
      type: Output
    }],
    lazyLoad: [{
      type: Output
    }]
  });
})();
